type DateConstantsType = {
  DELIVERY: {
    INTERVAL: {
      MONTHLY: 1;
      WEEKLY: 2;
      DAILY: 3;
    };
    SPECIFIED_DAY: {
      UNSPECIFIED: 0;
    };
  };
};

export const DATE_CONSTANTS: DateConstantsType = {
  DELIVERY: {
    INTERVAL: {
      MONTHLY: 1,
      WEEKLY: 2,
      DAILY: 3,
    },
    SPECIFIED_DAY: {
      UNSPECIFIED: 0,
    },
  },
} as const;

/**
 * monthCycleLabel
 * @description
 * 月サイクルの表示ラベル（1 → 「毎月」、2 → 「2ヵ月ごと」…）。
 *
 * **対応表ではなく規則で組む。** 選択肢は API が商品ごとのweb許可から組むが、
 * 管理画面の「webで許可するサイクル」に値の許可リストが無いため、4ヶ月・5ヶ月といった
 * 任意の月数を許可できる。閉じた対応表で持つと、表に無い値でラベルが空文字になる。
 *
 * **現サイクルの合流は obbs_api #699 で廃止された。** 以前は web許可に無い現サイクルも
 * 選択肢へ合流させて返していたが、現在は「現在のサイクルがweb許可に含まれる定期だけ
 * マイページで編集できる」（`canEdit: false` で編集画面に入れない）。
 *
 * 表記は front の既存表示（「2ヵ月ごと」）を維持する。API の `cycleText` は
 * 「2ヶ月ごと」で**カナが揺れている**が、本件では合わせない。
 * @param cycle 月数
 */
export const monthCycleLabel = (cycle: number): string =>
  cycle === 1 ? '毎月' : `${cycle}ヵ月ごと`;

/**
 * SELECTABLE_MONTH_FROM
 * 選択可能な月の最小値
 */
export const SELECTABLE_MONTH_FROM: number = 1;

/**
 * SELECTABLE_MONTH_TO
 * 選択可能な月の最大値
 */
export const SELECTABLE_MONTH_TO: number = 12;

/**
 * SELECTABLE_DAY_FROM
 * 選択可能な日の最小値
 */
export const SELECTABLE_DAY_FROM: number = 1;

/**
 * SELECTABLE_DAY_TO
 * 選択可能な日の最大値
 */
export const SELECTABLE_DAY_TO: number = 31;

/**
 * TOKEN_EXPIRE_MINUTES
 * クレジットカード認証トークンの有効期限（分）
 */
export const TOKEN_EXPIRE_MINUTES: number = 15;

/**
 * TOKEN_EXPIRE_MILLISECONDS
 * クレジットカード認証トークンの有効期限（ミリ秒）
 */
export const TOKEN_EXPIRE_MILLISECONDS: number = TOKEN_EXPIRE_MINUTES * 60 * 1000;
